import React, { useState, useEffect } from 'react';
import axios from 'axios';
import './PatentForm.css';
import { useNavigate } from 'react-router-dom';
import config from '../config/config';

const sectionOptions = [
  { key: 'claim', label: 'Claims' },
  { key: 'patent', label: 'Fullpatent' },
  { key: 'preamble', label: 'Preamble' },
  { key: 'transitional', label: 'Transitional phase' },
  { key: 'body', label: 'Body' },
  { key: 'dependent', label: 'Dependent Claims' },
  { key: 'description', label: 'Description' },






];

const FileViewer = () => {

  const BASE_URL = config.mode === "dev" ? config.URL : config.LiveURL;
  const [selectedSection, setSelectedSection] = useState('');
  const [content, setContent] = useState('');
  const [loading, setLoading] = useState(false);
  const [saving, setSaving] = useState(false);
  const [email, setEmail] = useState(localStorage.getItem("email"));
  const navigate = useNavigate();

  const fetchContent = async (sectionKey) => {
    setLoading(true);
    try {
      const res = await axios.get(`${BASE_URL}` + `api/file?section=${sectionKey}`);
      setContent(res.data.content);
    } catch (err) {
      setContent('Error loading content');
    }
    setLoading(false);
  };

  const handleSave = async () => {
    setSaving(true);
    try {
      await axios.post(`${BASE_URL}` + `api/file`, {
        section: selectedSection,
        content: content,
        email: email
      });
      alert('Updated successfully!');
    } catch (err) {
      alert('Error saving content');
    }
    setSaving(false);
  };

  useEffect(() => {
    if (selectedSection) {
      fetchContent(selectedSection);
    }
  }, [selectedSection]);

  return (
    <div style={{ padding: '20px', maxWidth: '800px', margin: 'auto' }}>
      <div style={{ display: "flex", justifyContent: "end", margin: "10px" }}>
        <button onClick={() => navigate('/patentform')} className="button secondary-button">
          Home Page
        </button>

      </div>
      <h2>Modify Prompt</h2>

      <label>Select Section:</label>
      <select
        value={selectedSection}
        onChange={(e) => setSelectedSection(e.target.value)}
        style={{ padding: '8px', marginBottom: '15px', display: 'block' }}
      >
        <option value="">-- Select Section --</option>
        {sectionOptions.map((option) => (
          <option key={option.key} value={option.key}>
            {option.label}
          </option>
        ))}
      </select>

      {loading ? (
        <p>Loading...</p>
      ) : (
        <>
          <textarea
            rows="15"
            cols="80"
            value={content}
            onChange={(e) => setContent(e.target.value)}
            className="textarea"
          ></textarea>

          <br />
          <button
            onClick={handleSave}
            disabled={saving}
            style={{ marginTop: '10px', padding: '10px 20px', fontSize: '16px' }}
          >
            {saving ? 'Saving...' : 'Update'}
          </button>
        </>
      )}
    </div>
  );
};

export default FileViewer;
